import { groq } from 'next-sanity';
import { z } from 'zod';

import { image, SanityImage } from './image';

export const SanityLogoWall = z.object({
  _type: z.literal('logoWall'),
  _key: z.string(),
  overline: z.string().optional().nullable(),
  logos: z.array(
    z.object({
      _key: z.string(),
      logo: SanityImage,
      logoWidth: z.number(),
      companyName: z.string(),
    }),
  ),
});
export type SanityLogoWall = z.infer<typeof SanityLogoWall>;

export const logoWall = groq`{
  _type,
  _key,
  overline,
  logos[] {
    _key,
    logo ${image},
    logoWidth,
    companyName,
  },
}`;
